import { Module } from "@/types/global"
import React from "react"

interface ModuleContextInterface {
  module: Module
}

const ModuleContext = React.createContext<ModuleContextInterface | null>(null)

export default ModuleContext
